import { IProcessRequest } from "../../model/request/IProcessRequest";
import { IDanhSachMienGiamSelectByLopsRequest } from "../../model/request/mien-giam/IDanhSachMienGiamSelectByLopsRequest";
import { apiClient } from "../apiClient";
export const MIEN_GIAM_ENDPOINT = "mien-giam";
export const duyetMienGiamApi = {
  SelectAllByLop: (request: IDanhSachMienGiamSelectByLopsRequest) =>
    apiClient.post(`${MIEN_GIAM_ENDPOINT}/select-by-lops`, request),
  DuyetAsync: (request: IProcessRequest<number[]>) =>
    apiClient.put(
      `${MIEN_GIAM_ENDPOINT}/duyet?process_id=${request.process_id}`,
      request.payload
    ),
  HuyDuyetAsync: (request: IProcessRequest<number[]>) =>
    apiClient.put(
      `${MIEN_GIAM_ENDPOINT}/huy-duyet?process_id=${request.process_id}`,
      request.payload
    ),
};
